<template>
  <el-pagination
    @size-change="fn_tableSizeChange"
    @current-change="fn_tableCurentChange"
    @prev-click="fn_tablePrevClick"
    @next-click="fn_tableNextClick"
    :page-sizes="lengthMenu"
    :page-size="limit"
    :current-page="page"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :pager-count="5"
  ></el-pagination>
</template>
<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    offset: {
      type: Number,
      default: 0
    },
    lengthMenu: {
      type: Array,
      default: () => {
        return [20, 40, 80, 120, 200, 500]
      }
    },
  },
  data() {
    return {
      limitValue: this.limit,
      pageValue: this.page,
      totalValue: this.total,
      offsetValue: this.offset,
    }
  },
  methods: {
    //Pagination
    fn_tableSizeChange(limit) {
      this.limitValue = limit
      this.fn_tableChangeOffset(this.page)
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page)
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page)
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page)
    },
    fn_tableChangeOffset(page) {
      this.pageValue = page
      this.offsetValue = (this.pageValue - 1) * this.limitValue
      this.$emit('changePagination', {
        page: this.pageValue,
        limit: this.limitValue,
        offset: this.offsetValue,
      })
    }
  },
  watch: {
    limit (newVal) {
      this.limitValue = newVal
    },
    page (newVal) {
      this.pageValue = newVal
    },
    total (newVal) {
      this.totalValue = newVal
    },
    offset (newVal) {
      this.offsetValue = newVal
    },
  }
}
</script>